import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';
import { isFuncComp } from '../../../../components/common/Helpers/index.js';

const shippingAdress = Loadable(() => (isFuncComp() ? import('../../FuncComponnetContainers/web/shippingAdress') : import('../../containers/web/shippingAdress')));

export default MapTo('vcg/components/soe-home/react/shippingAdress')(shippingAdress);
